import { useFormContext } from 'react-hook-form';
import { useContent } from 'src/contexts/ContentContext';
import { PosCurrencyField } from 'src/core/POS/PosCurrencyField';
import { ContentId } from 'src/utils/constants/contentId';
import {
  getAllInPriceFromListPrice,
  getListPriceFromAllinPrice,
} from 'src/utils/inventoryUtils';
import {
  ListingGroupAutoPriceSettings,
  UiCurrency,
} from 'src/WebApiController';

import * as styles from './PricingSetting.css';

interface PricingSettingManualPriceRankPremiumSettingsProps {
  uiCurrency: UiCurrency;
  sellerFee: number | null;
}

export const PricingSettingManualPriceRankPremiumSettings = ({
  uiCurrency,
  sellerFee,
}: PricingSettingManualPriceRankPremiumSettingsProps) => {
  const setStartingPriceText = useContent(ContentId.SetStartingPrice);

  const { watch, setValue } = useFormContext<ListingGroupAutoPriceSettings>();

  const startingPrice = watch('startingUnitNetProceeds');

  const handleValueChange = (value: string) => {
    const numericValue = parseFloat(value);

    if (!isNaN(numericValue)) {
      setValue(
        'startingUnitNetProceeds',
        getListPriceFromAllinPrice(numericValue, null, sellerFee) ?? null
      );
    } else if (numericValue < 0) {
      setValue('startingUnitNetProceeds', 0);
    } else {
      setValue('startingUnitNetProceeds', null);
    }
  };

  return (
    <div className={styles.rankPremiumContainer}>
      <PosCurrencyField
        rootProps={{
          className: styles.manualRankPremiumValueInputWrapper,
        }}
        className={styles.textAlignRight}
        uiCurrency={uiCurrency}
        prefixDisplay={
          <span className={styles.setPriceText}>{setStartingPriceText}:</span>
        }
        value={getAllInPriceFromListPrice(startingPrice, null, sellerFee) ?? ''}
        onChange={(e) => {
          return handleValueChange(e.target.value);
        }}
      />
    </div>
  );
};
